/* Lore Hoyuela — interacciones de las secciones lh-* */
(function () {
  function cardStep(track) {
    var card = track.firstElementChild;
    return card ? card.getBoundingClientRect().width + 12 : track.clientWidth * 0.8;
  }

  // Carruseles con flechas: [data-lh-carousel] contiene [data-lh-track], [data-lh-prev], [data-lh-next]
  function initCarousel(root) {
    if (root.__lh) return;
    root.__lh = true;
    var track = root.querySelector('[data-lh-track]');
    if (!track) return;
    var tabs = root.querySelectorAll('[data-lh-tab]');
    var current = 0;
    var lock = 0;

    // Índice de la tarjeta más cercana al inicio visible (al final del scroll, la última)
    function nearest() {
      var cards = track.children;
      if (!cards.length) return 0;
      if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 4) return cards.length - 1;
      var base = cards[0].offsetLeft, best = 0, dist = Infinity;
      for (var i = 0; i < cards.length; i++) {
        var d = Math.abs(cards[i].offsetLeft - base - track.scrollLeft);
        if (d < dist) { dist = d; best = i; }
      }
      return best;
    }
    function setActive(i) {
      current = i;
      tabs.forEach(function (t, j) { t.setAttribute('aria-selected', j === i ? 'true' : 'false'); });
    }
    function goTo(i) {
      var cards = track.children;
      i = Math.max(0, Math.min(cards.length - 1, i));
      var card = cards[i];
      if (!card) return;
      lock = Date.now() + 700; // evita que el scroll animado cambie la pestaña a mitad de camino
      track.scrollTo({ left: card.offsetLeft - cards[0].offsetLeft, behavior: 'smooth' });
      setActive(i);
    }

    // Flechas: avanza hasta la tarjeta que realmente mueve el carrusel
    function target(i) {
      var cards = track.children;
      return Math.min(cards[i].offsetLeft - cards[0].offsetLeft, track.scrollWidth - track.clientWidth);
    }
    function step(dir) {
      var n = track.children.length, i = current + dir;
      while (i > 0 && i < n - 1 && Math.abs(target(i) - track.scrollLeft) < 4) i += dir;
      goTo(i);
    }

    root.querySelectorAll('[data-lh-prev]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (tabs.length) step(-1);
        else track.scrollBy({ left: -cardStep(track), behavior: 'smooth' });
      });
    });
    root.querySelectorAll('[data-lh-next]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (tabs.length) step(1);
        else track.scrollBy({ left: cardStep(track), behavior: 'smooth' });
      });
    });

    if (!tabs.length) return;
    tabs.forEach(function (t, i) { t.addEventListener('click', function () { goTo(i); }); });
    var raf;
    track.addEventListener('scroll', function () {
      if (Date.now() < lock) return;
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () { setActive(nearest()); });
    }, { passive: true });
    root.__lhGoTo = goTo;
  }

  // Acordeón: solo uno abierto a la vez
  function initAccordion(root) {
    if (root.__lh) return;
    root.__lh = true;
    var items = root.querySelectorAll('details');
    items.forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (!d.open) return;
        items.forEach(function (o) { if (o !== d) o.open = false; });
      });
    });
  }

  // Pestañas de temas: [data-lh-tabs] con botones [data-lh-tabbtn] y paneles [data-lh-tabpanel]
  function initTabs(root) {
    if (root.__lh) return;
    root.__lh = true;
    var btns = root.querySelectorAll('[data-lh-tabbtn]');
    var panels = root.querySelectorAll('[data-lh-tabpanel]');
    function select(i, focus) {
      btns.forEach(function (b, j) {
        b.setAttribute('aria-selected', j === i ? 'true' : 'false');
        b.tabIndex = j === i ? 0 : -1;
      });
      panels.forEach(function (p, j) { p.hidden = j !== i; });
      if (focus) btns[i].focus();
    }
    btns.forEach(function (b, i) {
      b.addEventListener('click', function () { select(i); });
      b.addEventListener('keydown', function (e) {
        var n = btns.length;
        if (e.key === 'ArrowRight') { e.preventDefault(); select((i + 1) % n, true); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); select((i - 1 + n) % n, true); }
      });
    });
  }


  // Menús desplegables del header: clic, teclado (Escape) y hover en escritorio
  function initDrops(root) {
    root.querySelectorAll('[data-lh-drop]').forEach(function (li) {
      if (li.__lh) return; li.__lh = true;
      var btn = li.querySelector('.lh-drop__btn'), menu = li.querySelector('.lh-drop__menu'), t;
      function set(open) { menu.hidden = !open; btn.setAttribute('aria-expanded', open ? 'true' : 'false'); }
      btn.addEventListener('click', function (e) { e.stopPropagation(); set(matchMedia('(hover:hover)').matches ? true : menu.hidden); });
      li.addEventListener('mouseenter', function () { if (matchMedia('(hover:hover)').matches) { clearTimeout(t); set(true); } });
      li.addEventListener('mouseleave', function () { if (matchMedia('(hover:hover)').matches) { t = setTimeout(function () { set(false); }, 150); } });
      li.addEventListener('keydown', function (e) { if (e.key === 'Escape') { set(false); btn.focus(); } });
      document.addEventListener('click', function (e) { if (!li.contains(e.target)) set(false); });
    });
  }

  // Menú móvil
  function initHeader(root) {
    if (root.__lh) return;
    root.__lh = true;
    var btn = root.querySelector('[data-lh-burger]');
    var menu = root.querySelector('[data-lh-menu]');
    if (!btn || !menu) return;
    function set(open) {
      menu.hidden = !open;
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.textContent = open ? '✕' : '☰';
    }
    btn.addEventListener('click', function () { set(menu.hidden); });
    menu.addEventListener('click', function (e) { if (e.target.closest('a')) set(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') set(false); });
  }

  // Links "Membresía": llevan a #trabaja y mueven el carrusel a la primera tarjeta
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[data-lh-offer]');
    if (!a) return;
    var target = document.getElementById('trabaja');
    if (!target) return; // en otras páginas, el link sigue su URL normal
    e.preventDefault();
    target.scrollIntoView({ behavior: 'smooth' });
    var root = target.querySelector('[data-lh-carousel]');
    var i = parseInt(a.getAttribute('data-lh-offer'), 10) || 0;
    setTimeout(function () { if (root && root.__lhGoTo) root.__lhGoTo(i); }, 50);
    history.replaceState(null, '', '#trabaja');
  });

  function init(scope) {
    (scope || document).querySelectorAll('[data-lh-carousel]').forEach(initCarousel);
    (scope || document).querySelectorAll('[data-lh-accordion]').forEach(initAccordion);
    (scope || document).querySelectorAll('[data-lh-header]').forEach(initHeader);
    initDrops(scope || document);
    (scope || document).querySelectorAll('[data-lh-tabs]').forEach(initTabs);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();


  // Formularios de Shopify Forms: aplicar la marca dentro de su shadow DOM
  var FORM_CSS = [
    ':host{--lh-m:#142B4F;--lh-c:#C21F3A}',
    '*{font-family:"Archivo",system-ui,sans-serif!important;color:#142B4F}',
    '[class*="_textHeading_"],[class*="_textHeading_"]+p{display:none!important}',
    'input[type=text],input[type=email],input[type=tel],input[type=number],input[type=url],textarea,select{border:1px solid #A3AEC2!important;border-radius:16px!important;background:#FFFDF8!important;color:#142B4F!important;font-size:16px!important;padding:14px 16px!important;box-shadow:none!important}',
    'input:focus,textarea:focus,select:focus{outline:none!important;border-color:#142B4F!important;box-shadow:0 0 0 3px #D6E8F6!important}',
    'input::placeholder,textarea::placeholder{color:#2A4068!important;opacity:.7}',
    'input[type=radio],input[type=checkbox]{accent-color:#C21F3A}',
    'label{font-size:16px!important;line-height:1.45!important}',
    'button[type=submit],button{display:inline-flex!important;align-items:center!important;justify-content:center!important;line-height:1.2!important;border-radius:999px!important;min-height:54px!important;padding:0 28px!important;background:#C21F3A!important;border:1px solid #C21F3A!important;color:#F6F2E7!important;font-weight:700!important;letter-spacing:.04em!important;text-transform:uppercase!important;cursor:pointer}',
    'button[type=submit] *,button *{color:#F6F2E7!important}',
    'button:hover{background:#9C1830!important;border-color:#9C1830!important}',
    'a{color:#C21F3A!important}',
    'h1,h2,h3{font-family:"Bricolage Grotesque","Archivo",sans-serif!important;font-weight:800!important;letter-spacing:-.03em}'
  ].join('');
  function styleForms() {
    document.querySelectorAll('shopify-forms-embed').forEach(function (el) {
      var sr = el.shadowRoot;
      if (!sr || sr.querySelector('style[data-lh]')) return;
      var st = document.createElement('style');
      st.setAttribute('data-lh', '');
      st.textContent = FORM_CSS;
      sr.appendChild(st);
    });
  }
  styleForms();
  var formTries = 0, formTimer = setInterval(function () { styleForms(); if (++formTries > 40) clearInterval(formTimer); }, 250);


  // Testimonios de YouTube: cargar el reproductor solo al hacer clic
  document.addEventListener('click', function (e) {
    var f = e.target.closest('[data-lh-yt]');
    if (!f || f.querySelector('iframe')) return;
    var ifr = document.createElement('iframe');
    ifr.src = 'https://www.youtube-nocookie.com/embed/' + f.getAttribute('data-lh-yt') + '?autoplay=1&playsinline=1&rel=0';
    ifr.title = 'Testimonio de ' + (f.getAttribute('data-title') || 'cliente');
    ifr.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture';
    ifr.allowFullscreen = true;
    f.innerHTML = ''; f.appendChild(ifr);
  });


  // Video de portada: solo se descarga y reproduce solo en pantallas grandes (en celular, al tocar play)
  (function () {
    var big = window.matchMedia('(min-width: 769px)').matches;
    var save = navigator.connection && navigator.connection.saveData;
    if (!big || save) return;
    document.querySelectorAll('video[data-lh-autoplay]').forEach(function (v) {
      var start = function () { v.preload = 'auto'; var p = v.play(); if (p && p.catch) p.catch(function () {}); };
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { start(); io.disconnect(); } }); });
        io.observe(v);
      } else start();
    });
  })();

  // Re-inicializa al editar en el Personalizador de Shopify
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
